import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

// Function to check if the token is expired
const isTokenExpired = (expiresAt) => {
  if (!expiresAt) return true;
  const currentTime = Date.now();
  const expirationTime = new Date(expiresAt).getTime();
  return expirationTime <= currentTime;
};

const PrivateRout = ({ element: Component, ...rest }) => {
  const location = useLocation();
  const accessToken = sessionStorage.getItem('access_token');
  const expiresAt = sessionStorage.getItem('tokenExpirationTime');
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!accessToken || isTokenExpired(expiresAt)) {
      toast.warning("Please login to continue");
      setShouldRedirect(true); // Set state to trigger redirect
    }
  }, [accessToken, expiresAt]);

  if (shouldRedirect) {
    // Perform redirection after showing toast
    return <Navigate to="/skyblue" state={{ from: location }} />;
  }

  return <Component {...rest} />;
};

export default PrivateRout;


// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';

// const PrivateRout = ({ element: Component, ...rest }) => {
//   const location = useLocation();
//   const accessToken = sessionStorage.getItem('access_token');

//   return accessToken ? (
//     <Component {...rest} />
//   ) : (
//     <Navigate to="/skyblue" state={{ from: location }} />
//   );
// };

// export default PrivateRout;
